<!--
  @Description 测试进度饼图
  @Date 2022-01-09
  @Author liushuo
-->
<template>
  <div id="pieRight" :style="{ width: '250px', height: '300px' }"></div>
</template>

<script>
export default {
  name: 'pieRight',
  data () {
    return {
      testData: {
        todo: 0,
        ing: 0,
        completed: 0,
      },
    }
  },
  watch: {
    testData: {
      handler () {
        this.drawLine();
      },
      deep: true
    }
  },
  mounted () {
    this.drawLine();
  },
  methods: {
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('pieRight'))

      let option = {
        title: {
          text: '测试进度',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          top: '20%',
          left: 'center'
        },
        series: [
          {
            name: '测试进度',
            type: 'pie',
            radius: ['30%', '65%'],
            avoidLabelOverlap: false,
            center: ['50%', '65%'],
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '22',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: [
              { value: this.testData.todo, name: '待测试' },
              { value: this.testData.completed, name: '已完成' },
              { value: this.testData.ing, name: '测试中' },
            ]
          }
        ]
      };
      // 绘制图表
      myChart.setOption(option);
    }
  }
}
</script>

<style lang="less" scoped>
</style>
